// const Cf = {
//     DOMAIN_WS: 'dev_wss.vipchat.vn',
//     PORT_WS: 443,
//     SECURE_WS: true,
//     URL: 'https://dev.vipchat.vn',
//     WS: 'ws://dev_wss.vipchat.vn',
//     WS_URL: 'https://dev_wss.vipchat.vn',
//     STATIC: 'https://dev.vipchat.vn',
//     peerConnCfg: {
//         'iceServers': [{
//             'urls': 'turn:turn.vipchat.vn:3478',
//             'credential': 'bnc@123',
//             'username': 'truongnx'
//         }]
//     },
//     // peerConnCfg: {
//     //     'iceServers': [{
//     //         'urls': 'stun:stun.vipchat.vn:3478'
//     //     }, {
//     //         'urls': 'turn:turn.vipchat.vn:3478',
//     //         'credential': 'bnc@123',
//     //         'username': 'truongnx'
//     //     }]
//     // },
//     app: 'vipchat_developer',
//     cacheLife: 2, //2 Sec
//     version: 3.2
// };

//ADMIN

const Cf = {
    DOMAIN_WS: 'wss.vipchat.vn',
    PORT_WS: 443,
    SECURE_WS: true,
    URL: 'https://admin.vipchat.vn',
    WS: 'wss://wss.vipchat.vn',
    WS_URL: 'https://wss.vipchat.vn',
    STATIC: 'https://admin.vipchat.vn',
    peerConnCfg: {
        'iceServers': [{
            'urls': 'turn:turn.vipchat.vn:3478',
            'credential': 'bnc@123',
            'username': 'truongnx'
        }]
    },
    // peerConnCfg: {
    //     'iceServers': [{
    //         'urls': 'stun:stun.vipchat.vn:3478'
    //     }, {
    //         'urls': 'turn:turn.vipchat.vn:3478',
    //         'credential': 'bnc@123',
    //         'username': 'truongnx'
    //     }]
    // },
    app: 'vipchat_product',
    cacheLife: 2, //2 Sec
    version: 3.3
};

export default Cf;


// WEBPACK FOOTER //
// ./src/config/Config.js